import React, {useContext, useRef, useState} from 'react'

import cx from 'classnames'
import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useMount, useScroll} from '@s-ui/react-hooks'
import CardAddVehicle, {CardAddVehiclesSideBorderTypes, CardAddVehiclesSizes} from '@adv-mt/mt-card-add-vehicle'

const {SMALL, LARGE} = CardAddVehiclesSizes
const {LEFT_ROUNDED, RIGHT_ROUNDED} = CardAddVehiclesSideBorderTypes

const BASE_CLASS = 'mt-PanelAddVehicles'

const CARD_CLASS = `${BASE_CLASS}-card`
const SMALL_CARD_CLASS = `${BASE_CLASS}--small`
const LARGE_CARD_CLASS = `${BASE_CLASS}--large`
const FIRST_CARD_CLASS = `${CARD_CLASS}First`
const SECOND_CARD_CLASS = `${CARD_CLASS}Second`

const VERSUS_CLASS = `${BASE_CLASS}-versus`

const FIXED_CLASS = 'isFixed'

const VEHICLE_TYPES = {
  FIRST_VEHICLE: 'first',
  SECOND_VEHICLE: 'second'
}

const MOBILE_TOPBAR_HEIGHT = 47

const PanelAddVehicles = ({firstVehicle, secondVehicle, addVehicle = () => {}, removeVehicle = () => {}}) => {
  const panelAddVehiclesRef = useRef()
  const [offsetTop, setOffsetTop] = useState()

  const {domain} = useContext(Context)
  const config = domain.get('config')
  const isMobile = config.get('isMobile')

  const mobileOffsetTop = offsetTop - MOBILE_TOPBAR_HEIGHT

  useMount(() => {
    const element = panelAddVehiclesRef.current
    setOffsetTop(element.offsetTop)
  })

  const {i18n} = useContext(Context)
  const {position} = useScroll()

  const isSmallCard = position >= (isMobile ? mobileOffsetTop : offsetTop)
  const isLargeCard = position < (isMobile ? mobileOffsetTop : offsetTop)

  const PRIMARY_CLASS = cx(BASE_CLASS, {
    [FIXED_CLASS]: isSmallCard,
    [SMALL_CARD_CLASS]: isSmallCard,
    [LARGE_CARD_CLASS]: isLargeCard || !isSmallCard
  })

  const cardSize = isSmallCard ? SMALL : LARGE

  const versusText = i18n.t('COMMON.VERSUS').toUpperCase()

  const _handleAddVehicle = vehicleName => addVehicle(vehicleName)
  const _handleRemoveVehicle = vehicleName => removeVehicle(vehicleName)

  const {FIRST_VEHICLE, SECOND_VEHICLE} = VEHICLE_TYPES

  return (
    <div className={PRIMARY_CLASS} ref={panelAddVehiclesRef}>
      <div className={FIRST_CARD_CLASS}>
        <CardAddVehicle
          addVehicle={() => _handleAddVehicle(FIRST_VEHICLE)}
          removeVehicle={() => _handleRemoveVehicle(FIRST_VEHICLE)}
          sideBorder={LEFT_ROUNDED}
          size={cardSize}
          vehicle={firstVehicle}
        />
        <span className={VERSUS_CLASS}>{versusText}</span>
      </div>
      <div className={SECOND_CARD_CLASS}>
        <CardAddVehicle
          addVehicle={() => _handleAddVehicle(SECOND_VEHICLE)}
          removeVehicle={() => _handleRemoveVehicle(SECOND_VEHICLE)}
          sideBorder={RIGHT_ROUNDED}
          size={cardSize}
          vehicle={secondVehicle}
        />
      </div>
    </div>
  )
}

const vehiclePropTypes = {
  imageSrc: PropTypes.string.isRequired,
  make: PropTypes.string.isRequired,
  model: PropTypes.string.isRequired,
  version: PropTypes.string.isRequired
}

PanelAddVehicles.displayName = 'PanelAddVehicles'
PanelAddVehicles.propTypes = {
  addVehicle: PropTypes.func.isRequired,
  removeVehicle: PropTypes.func.isRequired,
  firstVehicle: PropTypes.shape(vehiclePropTypes),
  secondVehicle: PropTypes.shape(vehiclePropTypes)
}

export {VEHICLE_TYPES as vehicleTypes}
export default PanelAddVehicles
